export const typesOpServicios = {
    storeServiciosPorValidar: "[opServicios] storeServiciosPorValidar",
    storeServicioPorValidar: "[opServicios] storeServicioPorValidar",
    setLoading: "[opServicios] setLoading",
    
    
}